import { CanActivateFn, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { inject } from '@angular/core';
import { PermissionService } from '../services/permission.service.ts.service';
import { NotificationService } from '../services/Motor_leasing/notification.service';
import { Role } from '../models/role.enum';

export const roleGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
) => {
  const permissionService = inject(PermissionService);
  const notificationService = inject(NotificationService);
  const router = inject(Router);

  const expectedRoles: Role[] = route.data['expectedRole'] || [];
  const requiredPermissions: string[] = route.data['requiredPermissions'] || [];

  const userRole = permissionService.getRole();

    if (!userRole) {
      notificationService.show('error', 'Session expired. Please login again.');
      router.navigate(['/admin-login']);
      return false;
    }


  const hasValidRole = expectedRoles.length === 0 || permissionService.hasAnyRole(expectedRoles);
  const hasPermissions = requiredPermissions.length === 0 || permissionService.hasAll(requiredPermissions);

  if (hasValidRole && hasPermissions) {
    return true;
  }

 
  notificationService.show('error', 'Unauthorized: You don’t have permission to access this page.');
  router.navigate(['/unauthorized']);
  return false;
};
